// src/views/Home/Home.js
import React from "react";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "../../utils/constants";
import Banner from "../../components/Banner/Banner";
import enteteImage from "../../assets/entete.webp";
import "./Home.scss";

function Home({ isAuthenticated }) {
  // const [projets, setProjets] = useState([]);
  // console.log("API_URL =", process.env.REACT_APP_API_URL);

  // useEffect(() => {
  //   getProjets()
  //     .then((formData) => {
  //       console.log("PROJETS =", formData);
  //       setProjets(formData);
  //     })
  //     .catch((error) => console.error("Error fetching projets:", error));
  // }, []);

  return (
    <div className="App">
      <main>
        {/* 🔹 BANNIÈRE */}
        {/* <div className="container"> */}
        <Banner
          img={enteteImage}
          title="Développeuse web / mobile fullstack"
          subtitle="Je conçois et développe des applications web et mobile du recueil des besoins jusqu'au déploiement."
          alt="image décorative d'un ordinateur portable"
        />
        {/* </div> */}
        <div className="presentation-container">
          <section className="presentation">
            <h2>Bienvenue sur mon portfolio !</h2>
            <p>
              Je suis une développeuse web et mobile passionnée, spécialisée
              dans la <strong>création d'applications web et mobile{" "}
              sur mesure, simples et performantes </strong>.{" "}
              <strong>
                Je combine une approche technique avec une forte compréhension
                des enjeux fonctionnels et métiers.{" "}
              </strong>
              <p>Cette double compétence me permet de : </p>
              <ul>
                <li>comprendre rapidement les besoins réels des utilisateurs,</li>
                <li>traduire les attentes métier en solutions techniques faciles à utiliser,</li>
                <li>travailler efficacement avec des équipes techniques et non
                  techniques.</li>
              </ul>
            <p> 
              Ma valeur différenciante réside dans le fait que j'ai une longue expérience de gestion de projets de A à Z. Ainsi en tant que chef de projet, j’interviens dès la définition du besoin, en passant par le maquettage, le développement, les tests et le déploiement, avec une attention particulière portée à
              la qualité des livrables.
            </p>
            </p>
            <p>
              Je suis constamment à la recherche de <strong> nouveaux défis</strong> à relever pour <strong>concevoir et mettre en œuvre des solutions digitales efficaces.</strong> 
            </p>
          </section>
        </div>

        <div className="cta-projets">
          <Link to="/Projets" className="cta-button">
            Voir mes projets
          </Link>
        </div>

        {/* 🔹 BOUTON ADMIN */}
        <div className="container">
          <div className="button_container">
            {isAuthenticated && (
              <Link to={APP_ROUTES.ADD_PROJET} className="add_projet_button">
                Ajouter un projet
              </Link>
            )}
          </div>
        </div>

        {/* 🔹 PROJETS */}
        {/* <div className="container">
          <section className="Projet-wrapper">
            <div className="Projet-grid">
              {projets.map(({ id, title, imageUrl }) => (
                <Card key={id} title={title} imageUrl={imageUrl} id={id} />
              ))}
            </div>
          </section>
        </div> */}
      </main>
    </div>
  );
}

export default Home;
